// src/lib/legal.ts
// ─────────────────────────────────────────────────────────────────────────────
// Configuration légale centralisée — source unique pour les pages
// /mentions-legales, /confidentialite, /corrections et le footer.
//
// ⚠️  À COMPLÉTER PAR L'ÉDITEUR avant mise en ligne. Les valeurs marquées
//     « À COMPLÉTER » sont des placeholders. Faire valider l'ensemble par un
//     avocat presse/IT (voir audit juridique). Tant qu'une valeur n'est pas
//     renseignée, la page concernée affiche un avertissement visible.
// ─────────────────────────────────────────────────────────────────────────────

export const TODO = 'À COMPLÉTER' as const;

/** Renvoie true si la valeur est encore un placeholder non renseigné. */
export function isPending(value: string): boolean {
  return value.trim() === TODO || value.trim() === '';
}

export const LEGAL = {
  // Nom public du service
  siteName: 'Lumière Noire',
  siteUrl: process.env.NEXT_PUBLIC_SITE_URL ?? 'https://lumiere-noire.fr',

  // ── Éditeur du site (LCEN art. 6-III) ─────────────────────────────────────
  // Personne physique ou morale qui édite le service.
  editor: {
    // Ex. « David Roche » (personne physique) ou « Lumière Noire SAS » (société)
    name: TODO,
    // « Personne physique » | « SAS » | « Association loi 1901 » | « EI / micro-entreprise »…
    legalForm: TODO,
    // Adresse postale. Une personne physique non professionnelle peut, sous LCEN,
    // ne communiquer son adresse qu'à l'hébergeur — dans ce cas laisser « À COMPLÉTER »
    // ici et s'assurer que l'identité est bien déposée chez l'hébergeur.
    address: TODO,
    // N° SIREN/SIRET si professionnel, sinon laisser vide
    registration: '',
    // Capital social si société, sinon vide
    capital: '',
    email: TODO, // ex. contact@lumiere-noire.fr
  },

  // ── Directeur de la publication (loi 1881 / LCEN) ─────────────────────────
  publicationDirector: {
    name: TODO, // responsable du contenu éditorial publié
  },

  // ── Hébergeur (LCEN art. 6-III) ───────────────────────────────────────────
  host: {
    name: TODO, // ex. « Vercel Inc. », « OVH SAS »…
    address: TODO,
    contact: TODO, // téléphone ou email/URL de l'hébergeur
  },

  // ── Délégué / contact protection des données (RGPD) ───────────────────────
  dataContact: {
    email: TODO, // ex. privacy@lumiere-noire.fr (peut être identique à editor.email)
  },

  lastUpdated: '2026-06-13',
} as const;

// ── Mention IA réutilisable (transparence — AI Act) ──────────────────────────
export const AI_DISCLOSURE_SHORT =
  "Analyse produite avec l'assistance de l'intelligence artificielle, selon un protocole méthodologique documenté, et relue par la rédaction avant publication.";

export const AI_DISCLOSURE_LONG =
  "Les analyses de Lumière Noire sont produites à l'aide de modèles d'intelligence artificielle appliquant un protocole identique à tous les sujets, puis relues et validées par un humain avant publication. Elles s'appuient sur des sources publiques citées. Elles peuvent comporter des erreurs ou des imprécisions : elles constituent une analyse, non une vérité judiciaire ou un fait établi. Toute personne concernée peut demander une correction ou exercer un droit de réponse.";
